var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"absence-chip",class:{
    'came-later': false === _vm.isAbsent && _vm.studentAbsence.cameLater > 0,
    'left-earlier': false === _vm.isAbsent && _vm.studentAbsence.leftEarlier > 0,
    'empty': typeof _vm.isAbsent != 'boolean'
  },style:({borderColor: _vm.color}),attrs:{"title":_vm.studentAbsence.comment}},[(_vm.showIcon)?_c('v-icon',{attrs:{"x-small":""},domProps:{"textContent":_vm._s(_vm.icon)}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.code))]),(false === _vm.isAbsent)?_c('v-icon',{staticClass:"d-none d-print-inline",attrs:{"size":"18","color":_vm.color}},[_vm._v("mdi-check-circle-outline")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }